import { render, staticRenderFns } from "./PacienteOrtopantomografo.vue?vue&type=template&id=4ee1ff74&scoped=true"
import script from "./PacienteOrtopantomografo.vue?vue&type=script&lang=js"
export * from "./PacienteOrtopantomografo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee1ff74",
  null
  
)

export default component.exports